const state = () => ({
  registeredStatus: 'not_registered',
  isModalVisible: false,
  links: []
})

const mutations = {
  set (state, { type, payload }) {
    state[type] = payload
  }
}

export { state, mutations }
